import React, { useEffect, useState } from "react";

import {
  Grid,
  Box,
  Spinner,
  Image,
} from "@chakra-ui/react";
import Uploader from "./Uploader";
import Delete from "./Delete";

function Images() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastId, setLastId] = useState(0);

  useEffect(() => {
    fetch("https://media.seamarinetransport.com/php/get_images.php", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Error al cargar imágenes");
        return res.json();
      })
      .then((data) => {
        const sorted = data.sort((a, b) => +b.id - +a.id);
        setImages(sorted);
      })
      .catch((err) => {
        console.error("Error:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    let newId = +images[0]?.id + 1 || 0;
    setLastId(newId);
  }, [images]);

  if (loading)
    return (
      <Spinner
        position="fixed"
        zIndex="9999"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.500"
        size="md"
      />
    );

  return (
    <div>
      <Uploader id={lastId} setImages={setImages} images={images} />
      <Grid
        padding="1rem 1rem 3rem 1rem"
        templateColumns="repeat(auto-fit,minmax(10rem,1fr))"
        justifyContent="center"
        gap="1rem"
      >
        {images.map((image) => (
          <Box
            key={image.id}
            width="auto"
            background="white"
            rounded={4}
            position="relative"
            padding=".5rem"
            gap=".5rem"
            justifyContent="space-between"
            boxShadow="sm"
          >
            <Image
              border="1px solid gray.200"
              boxShadow="sm"
              rounded="md"
              src={`https://media.seamarinetransport.com/img/thumb/${image.name}`}
              key={image.id}
            />
            <Delete id={image.id} onDelete={setImages} images={images} />
          </Box>
        ))}
      </Grid>
    </div>
  );
}

export default Images;
